var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon icon-shape",class:[
        _vm.size && ("icon-" + _vm.size),
        _vm.type && ("icon-shape-" + _vm.type),
        _vm.gradient && ("bg-gradient-" + _vm.gradient),
        _vm.shadow && 'shadow',
        _vm.rounded && 'rounded-circle',
        _vm.color && ("text-" + _vm.color)
     ]},[_vm._t("default",[_c('i',{class:_vm.name})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-849a3e54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icon.vue
// module id = null
// module chunks = 